import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as _ from 'lodash';
import { WebSocketComponentStatus } from '../../utils/enums/websocket-component-status.enum';
import { WebSocketStatus } from '../../utils/enums/websocket-status.enum';
import { AiStatus } from '../../utils/enums/gem-ai-status.enum';

export interface IGemMediaDownloadData {
  url?: string;
  status?: WebSocketComponentStatus;
  error?: string;
  gemId?: string;
  loadingStage?: string;
}

export interface IGenerateGemPassportData {
  status?: WebSocketComponentStatus;
  error?: string;
  gemId?: string;
  uginId?: string;
}

export interface IGemAiStatusData {
  aiStatus?: AiStatus;
  gemId?: string;
  aiTryAttempts?: number;
}

export interface IWebsocketSlice {
  componentStatus: { [name: string]: undefined | string | boolean | number };
  gemMediaDownloadData: IGemMediaDownloadData;
  generateGemPassportData: IGenerateGemPassportData;
  websocketStatus: WebSocketStatus;
  gemAiStatusdata: IGemAiStatusData | null;
}

const initialState: IWebsocketSlice = {
  websocketStatus: WebSocketStatus.CONNECTING,
  componentStatus: {},
  gemMediaDownloadData: {
    status: WebSocketComponentStatus.PENDING,
  },
  generateGemPassportData: {
    status: WebSocketComponentStatus.PENDING,
  },
  gemAiStatusdata: null,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setComponentStatus(
      state: IWebsocketSlice,
      action: PayloadAction<{ [key: string]: undefined | string | boolean | number }>,
    ) {
      state.componentStatus = { ...state.componentStatus, ...action.payload };
    },
    clearComponentStatus(state: IWebsocketSlice, action: PayloadAction<string[] | undefined>) {
      if (action.payload?.length) {
        state.componentStatus = _.omit(state.componentStatus, action.payload);
      } else {
        state.componentStatus = {};
      }
    },
    setWebSocketStatus(state: IWebsocketSlice, action: PayloadAction<WebSocketStatus>) {
      state.websocketStatus = action.payload;
    },

    connectWebSocket(_state: IWebsocketSlice) {},
    disconnectWebSocket(_state: IWebsocketSlice, _action: PayloadAction<{}>) {},
    onGemPassportGeneratedAsync: (_state, _action: PayloadAction<{ data: IGenerateGemPassportData }>) => {},
    onGetGemAiStatusAsync: (_state, _action: PayloadAction<{ data: IGemAiStatusData }>) => {},
    onGemMediaZippedAsync: (_state, _action: PayloadAction<{ data: IGemMediaDownloadData }>) => {},
    setGemMediaDownloadData(state: IWebsocketSlice, action: PayloadAction<IGemMediaDownloadData>) {
      state.gemMediaDownloadData = { ...action.payload };
    },
    clearGemMediaDownloadData(state: IWebsocketSlice) {
      state.gemMediaDownloadData = {
        status: WebSocketComponentStatus.PENDING,
        gemId: '',
        url: '',
      };
    },
    setGenerateGemPassportData(state: IWebsocketSlice, action: PayloadAction<IGenerateGemPassportData>) {
      state.generateGemPassportData = { ...action.payload };
    },

    setGemAiStatusData(state: IWebsocketSlice, action: PayloadAction<IGemAiStatusData | null>) {
      state.gemAiStatusdata = action.payload;
    },

    clearGenerateGemPassportData(state: IWebsocketSlice) {
      state.generateGemPassportData = {
        status: WebSocketComponentStatus.PENDING,
        gemId: '',
      };
    },
  },
});

export const { actions: websocketActions, reducer: websocketReducer } = websocketSlice;
